import objectPath from 'object-path'

export const dataSeries = [
  {
    value: 'data',
    label: '[ data ]',
    params: ['labels', 'series'],
    responseKey: ['labels', 'series'],
    chartKey: ['options.labels', 'series'],
  },
  {
    value: 'name.data',
    label: 'name, [ data ]',
    params: ['serieName', 'serieData'],
    responseKey: ['series', 'categories'],
    chartKey: ['series', 'options.categories'],
  },
  {
    value: 'name.xy',
    label: 'name, { x,y }',
    params: ['serieName', 'serieX', 'serieY'],
    responseKey: ['series'],
    chartKey: ['series'],
  },
  {
    value: 'name.x.duration',
    label: 'name, { x,duration }',
    params: ['serieName', 'serieX', 'startY', 'endY'],
    responseKey: ['series'],
    chartKey: ['series'],
  },
]

export const createSeriesAndLabel = (response, rowData, chartData) => {
  let { labels = [], series = [] } = response
  let mapDataSource = []
  labels.forEach((dataName, index) => {
    let dataValue = series[index]
    mapDataSource.push({
      dataSource: rowData?.key,
      dataName: dataName,
      dataValue: dataValue,
    })
  })
  objectPath.set(chartData, 'mapDataSource', mapDataSource)
  return chartData
}

export const createNameAndData = (response, rowData, chartData) => {
  let { series = [] } = response
  let mapDataSource = []
  series.forEach(({ name = '', data = [] }) => {
    mapDataSource.push({
      dataSource: rowData?.key,
      dataName: name,
      dataValue: data,
    })
  })
  objectPath.set(chartData, 'mapDataSource', mapDataSource)
  return chartData
}

export const createNameAndDuration = (response, rowData, chartData) => {
  let { series = [] } = response
  let mapDataSource = []
  series.forEach(({ name = '', data = [] }) => {
    data.map((item) => {
      if (item.start) {
        item.y[0] = new Date(item.start).getTime()
      }
      if (item.end) {
        item.y[1] = new Date(item.end).getTime()
      }
      return item
    })
    mapDataSource.push({
      dataSource: rowData?.key,
      dataName: name,
      dataValue: data,
    })
  })
  objectPath.set(chartData, 'mapDataSource', mapDataSource)
  objectPath.set(chartData, 'options.xaxis.type', 'datetime')
  objectPath.set(chartData, 'options.xaxis.convertedCatToNumeric', 'false')
  return chartData
}
